import axios from 'axios'
import type { ApiTemplatePayload, ApiTemplateResponse } from '@/views/email/utils/apiTransformers'

export interface EmailTemplateListItem {
  id: string
  name: string
  created_at: string
}

export default function useEmailContent() {
  const listTemplates = async (): Promise<EmailTemplateListItem[]> => {
    const { data } = await axios.get<{ data: Record<string, unknown>[] }>('merchants/email-contents/templates')
    return data.data.map((item) => ({
      id: String(item.id),
      name: String(item.name ?? ''),
      created_at: String(item.created_at ?? '')
    }))
  }

  const getEmailContent = async (id: string) => {
    const { data } = await axios.get<{ data: ApiTemplateResponse }>(`merchants/email-contents/${id}`)
    return data.data
  }

  const createEmailContent = async (payload: ApiTemplatePayload) => {
    const { data } = await axios.post<{ data: ApiTemplateResponse }>('merchants/email-contents', payload)
    return { ...data.data, id: String(data.data.id) }
  }

  const updateEmailContent = async (id: string, payload: ApiTemplatePayload) => {
    await axios.put(`merchants/email-contents/${id}`, payload)
  }

  const createFromTemplate = async (templateId: string, name?: string) => {
    const { data } = await axios.post<{ data: { id: number | string } }>(
      `merchants/email-contents/${templateId}/create-from-template`,
      name ? { name } : {}
    )
    return { id: String(data.data.id) }
  }

  const saveAsTemplate = async (payload: ApiTemplatePayload) => {
    const { data } = await axios.post<{ data: ApiTemplateResponse }>('merchants/email-contents', {
      ...payload,
      is_template: true
    })
    return data.data
  }

  const uploadImage = async (file: { base64: string; originalName: string }) => {
    const { data } = await axios.post('merchants/email-contents/upload-image', {
      image: file.base64,
      original_name: file.originalName
    })
    return data?.data?.url || data?.url
  }

  const sendTestEmail = async (id: string, to: string, locale: string) => {
    await axios.post(`merchants/email-contents/${id}/send-test?locale=${locale}`, { to })
  }

  return {
    listTemplates,
    getEmailContent,
    createEmailContent,
    updateEmailContent,
    createFromTemplate,
    saveAsTemplate,
    uploadImage,
    sendTestEmail
  }
}
